import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const getPopupState = (state: BP42InitialState): boolean => state._popup.open;

export default getPopupState;
